import { Component, Injector } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchDialogComponent } from '@Work/Accounts/proprietary/controls/search-dialog.component';
import { AppService } from '@Core/services/proprietary/app.service';
import { DataService } from '@Core/services/proprietary/data.service';

@Component({
    standalone: false,
    selector: 'agreement-search-dialog',
    templateUrl: './agreement-search-dialog.component.html',
    providers: [DataService] //force as a local provider
})
export class AgreementSearchDialogComponent extends SearchDialogComponent {
    constructor(private injector: Injector, private activeModal: NgbActiveModal, public app: AppService) {
        super(injector);
    }

    //Override Method: called to construct initialize the search component
    initialize(): boolean {
        this.parentActiveModal = this.activeModal;

        this.objectType = 'DBQuery';
        this.model.criteria.Procedure_Name = 'epx_tempopenagreementsearch';
        this.model.criteria.View = 'Full';
        this.model.title = 'Select Agreement';

        this.model.criteria.Book_Entity_ID = 'CURRENTBOOK';
        this.model.criteria.Max = this.model.currentOptions.maxRows;

        return true;
    }
}
